import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { OUTER_BORDERS_UNLOADED, OUTER_BORDERS_LOADED } from '../constants/actionTypes';
import Banner from './Home/Banner';
import Footer from './Home/Footer';

const mapStateToProps = state => ({
  ...state.home,
  appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
  onLoad: () =>
    dispatch({ type: OUTER_BORDERS_LOADED }),
  onUnload: () =>
    dispatch({ type: OUTER_BORDERS_UNLOADED })
});

class Monuments extends React.Component {
  render() {
    return (
      <div className="home-page">

        <Banner
          appName={this.props.appName}
        />

        <div className="container page">
          <div className="row" >
            <Link id="monuments-black-main-card" className="nav-object col-md-6" to="/monuments-black">
              <h2 > Melni </h2>
            </Link>
            <Link id="monuments-brownandgray-main-card" className="nav-object col-md-6" to="/monuments-brownandgray">
              <h2 > Brūni un Pelēki </h2>
            </Link>
          </div>

          <div className="row" >
            <Link id="monuments-boulders-main-card" className="nav-object col-md-6" to="/monuments-boulders">
              <h2 > Laukakmeņi </h2>
            </Link>
            <Link id="monuments-polished-main-card" className="nav-object col-md-6" to="/monuments-polished">
              <h2 > Ar pulētām malām </h2>
            </Link>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Monuments);


// WEBPACK FOOTER //
// ./src/components/Monuments.js